import React, { useContext, useEffect } from "react";
import { emitLinkingNotification, emitUpsellNotification } from "@catchoftheday/analytics";
import { Link } from "@catchoftheday/cg-components";
import { CustomerContext } from "@catchoftheday/customer";
import { URL_CATCH_HELP_CENTRE_SUBMIT_REQUEST } from "@header/consts";
import { getQueryStringValue } from "@header/utilities";
import { showToast } from "../utils";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var useOnePassNotification = function useOnePassNotification() {
  var _membership$subscript6, _membership$subscript7;

  var _useContext = useContext(CustomerContext),
      customer = _useContext.data;

  var _ref = customer || {},
      membership = _ref.membership,
      club = _ref.club;

  var showMessageQueryParam = getQueryStringValue("showmessage");
  useEffect(function () {
    if (customer && (showMessageQueryParam === "u" || showMessageQueryParam === "l")) {
      var message = "";
      var toastMessage = "";
      var isError = false;

      if (!(membership !== null && membership !== void 0 && membership.linked)) {
        isError = true;
        toastMessage = ___EmotionJSX(React.Fragment, null, "There was a problem in linking your OnePass account.", ___EmotionJSX("br", null), "Please submit an", " ", ___EmotionJSX(Link, {
          href: URL_CATCH_HELP_CENTRE_SUBMIT_REQUEST,
          target: "_blank",
          color: "inherit",
          textDecoration: "underline"
        }, "enquiry for assistance"), ".");
        message = "Accounts could not be linked";
      } else {
        var _membership$subscript, _membership$subscript2, _membership$subscript3, _membership$subscript4, _membership$subscript5;

        if (!(club !== null && club !== void 0 && club.active) && !(membership !== null && membership !== void 0 && (_membership$subscript = membership.subscription) !== null && _membership$subscript !== void 0 && _membership$subscript.active)) {
          message = toastMessage = "Catch and OnePass accounts linked. No active subscription found.";
        } else if (!(club !== null && club !== void 0 && club.active) && membership !== null && membership !== void 0 && (_membership$subscript2 = membership.subscription) !== null && _membership$subscript2 !== void 0 && _membership$subscript2.active && membership !== null && membership !== void 0 && (_membership$subscript3 = membership.subscription) !== null && _membership$subscript3 !== void 0 && _membership$subscript3.onFreeTrial) {
          message = toastMessage = showMessageQueryParam === "l" ? "Catch and OnePass accounts linked." : "OnePass free trial activated.";
        } else if (!(club !== null && club !== void 0 && club.active) && membership !== null && membership !== void 0 && (_membership$subscript4 = membership.subscription) !== null && _membership$subscript4 !== void 0 && _membership$subscript4.active && !(membership !== null && membership !== void 0 && membership.subscription.onFreeTrial)) {
          message = toastMessage = showMessageQueryParam === "l" ? "Catch and OnePass accounts linked." : "OnePass subscription activated.";
        } else if (club !== null && club !== void 0 && club.active && !(membership !== null && membership !== void 0 && (_membership$subscript5 = membership.subscription) !== null && _membership$subscript5 !== void 0 && _membership$subscript5.active) && showMessageQueryParam === "l") {
          message = toastMessage = "Catch and OnePass accounts linked.";
        }
      }

      if (message) {
        if (showMessageQueryParam === "u") {
          emitUpsellNotification({
            type: isError ? "error" : "success",
            message: message
          });
        } else if (showMessageQueryParam === "l") {
          emitLinkingNotification({
            type: isError ? "error" : "success",
            message: message
          });
        }

        showToast({
          message: toastMessage,
          isError: isError,
          options: typeof toastMessage !== "string" ? {
            autoClose: false,
            closeButton: true
          } : {}
        });
      }
    }
  }, [club === null || club === void 0 ? void 0 : club.active, customer, membership === null || membership === void 0 ? void 0 : membership.linked, membership === null || membership === void 0 ? void 0 : (_membership$subscript6 = membership.subscription) === null || _membership$subscript6 === void 0 ? void 0 : _membership$subscript6.active, membership === null || membership === void 0 ? void 0 : (_membership$subscript7 = membership.subscription) === null || _membership$subscript7 === void 0 ? void 0 : _membership$subscript7.onFreeTrial, showMessageQueryParam]);
};